import { Settings } from '../types/settings.types';

export function parseClearName(settings: Settings, name: string) {
  const { separator } = settings.naming;

  const clearFullName = name.split(separator.empty)[0];

  return clearFullName;
}
